import { alpha } from '@mui/material/styles';

import type { SxProps, Theme } from '@mui/material/styles';

export const INVENTORY_THUMB_PX = 56;

export const inventoryItemTitleSx: SxProps<Theme> = (theme) => ({
    fontFamily: theme.typography.openSans.subtitle1Medium.fontFamily,
    fontSize: '15px',
    fontWeight: 600,
    lineHeight: '24px',
    color: alpha(theme.palette.common.black, 0.85),
});

export const inventoryDataCellSx: SxProps<Theme> = {
    verticalAlign: 'middle',
};

export const inventoryUomCellTypographySx: SxProps<Theme> = (theme) => ({
    ...theme.typography.openSans.body2,
    color: alpha(theme.palette.common.black, 0.85),
});

export const columnWidths: Record<string, string> = {
    thumbnail: '76px',
    sku: '112px',
    qtyPerUom: '56px',
    minOnHand: '112px',
    buttons: '156px',
};
